import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showBrandModal: false,
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    brandModal: (state, action) => {
      state.showBrandModal = action.payload;
    },
  },
});

export const { brandModal } = modalSlice.actions;

export default modalSlice.reducer;
